export default interface ILoginFormData {
  userName: string;
  password: string;
}

export class LoginFormData implements ILoginFormData {
  userName: string;
  password: string;
  constructor(username: string, password: string) {
    this.userName = username;
    this.password = password;
  }
}

const DefaultLoginFormData = new LoginFormData("", "");
export { DefaultLoginFormData };
